import { useNavigate } from 'react-router-dom';
import ProjectForm from '@/pages/projects/components/ProjectForm';

export default function NewProjectPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-add-circle-line text-lg"></i>
        </span>
        <div>
          <p className="text-sm font-semibold text-foreground-900">Registrar un nuevo proyecto</p>
          <p className="mt-0.5 text-sm text-foreground-600">
            Complete la información. Los campos marcados con <strong>*</strong> son obligatorios.
          </p>
        </div>
      </div>

      <ProjectForm
        mode="create"
        onSaved={(project) => navigate(`/proyectos/${project.id}`)}
        onCancel={() => navigate('/proyectos')}
      />
    </div>
  );
}